import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onMounted, ref, nextTick } from 'vue';
import PackagesAnnouncementModal from './PackagesAnnouncementModal.vue';
import { UserModalsApi } from '@/api/UserModalsApi';

// После того как модалку уже показали/закрыли — не дёргаем эндпоинт повторно
// в рамках этой сессии вкладки (постоянный флаг). Приложение — MVC с Vue-островками,
// поэтому каждая навигация = новая загрузка страницы и ремонт компонента.
// Ключи свои: чужое состояние (например upsellAfterCancel.*) не переиспользуем,
// иначе одна модалка блокировала бы другую.
const SESSION_SKIP_KEY = 'packagesAnnouncement.skip';

// Ответ shouldShow=false кэшируем ненадолго (метка времени последней проверки):
// это отсекает запрос на каждой загрузке страницы, но состояние успеет переоткрыться
// по истечении TTL — например когда пользователь закрыл тарифную модалку,
// которой анонс уступал.
const SESSION_NOTHING_KEY = 'packagesAnnouncement.checkedAt';
const NOTHING_TTL_MS = 10 * 60 * 1000;


export default /*#__PURE__*/_defineComponent({
  __name: 'PackagesAnnouncementModals',
  setup(__props) {

// Самодостаточный хост модалки-анонса пакетов 3/6/12 месяцев (FINCH-2446): сам запрашивает
// getPackagesAnnouncementModalInfo при входе и показывает модалку.
// Бэкенд гарантирует, что анонс уступает тарифным модалкам и апселлу после отмены,
// поэтому сам хост с другими хостами не координируется. Монтирование хоста при этом закрыто
// гейтом модалки о сбое (FINCH-2630, otherEntryModalsAllowed в TariffNotificationModals.vue).
const modalRef = ref<InstanceType<typeof PackagesAnnouncementModal> | null>(null);
const shouldShow = ref(false);
let dismissed = false;

async function onDismiss() {
    if (!shouldShow.value || dismissed) {
        return;
    }
    dismissed = true;
    sessionStorage.setItem(SESSION_SKIP_KEY, '1');
    try {
        await new UserModalsApi().dismissPackagesAnnouncementModal();
    } catch (e) {
        console.error(e);
    }
}

async function onConfirm() {
    await onDismiss();
    window.location.href = '/PaidFeatures';
}

onMounted(async () => {
    if (sessionStorage.getItem(SESSION_SKIP_KEY)) {
        return;
    }
    const checkedAt = Number(sessionStorage.getItem(SESSION_NOTHING_KEY));
    if (checkedAt && Date.now() - checkedAt < NOTHING_TTL_MS) {
        return;
    }
    try {
        const info = await new UserModalsApi().getPackagesAnnouncementModalInfo();
        if (!info?.entity?.shouldShow) {
            // Кэшируем «нечего показывать» только для настоящего ответа бэка.
            // При ошибке/редиректе на логин get() возвращает undefined (info == null) —
            // такой результат НЕ кэшируем, иначе неавторизованный ранний запрос
            // заблокировал бы показ на весь TTL.
            if (info?.isSuccess) {
                sessionStorage.setItem(SESSION_NOTHING_KEY, String(Date.now()));
            }
            return;
        }
        shouldShow.value = true;
        await nextTick();
        modalRef.value?.show();
    } catch (e) {
        console.error(e);
    }
});

return (_ctx: any,_cache: any) => {
  return (shouldShow.value)
    ? (_openBlock(), _createBlock(PackagesAnnouncementModal, {
        key: 0,
        ref_key: "modalRef",
        ref: modalRef,
        onConfirm: onConfirm,
        onHidden: onDismiss
      }, null, 512))
    : _createCommentVNode("", true)
}
}

})